import {DetailActions} from 'mc/lib/detail';
import {indexById} from 'mc/lib/utils';
import {Api} from '../api';

const AREA = 'currentZadost';

export function fetchIfNeeded(id, priloha = false, subjekt = false, lokalita = false) {
    const key = `${id}/${priloha}/${subjekt}/${lokalita}`;
    return DetailActions.fetchIfNeeded(AREA, key, () => Api.getZadost(id, priloha, subjekt, lokalita));
}

export function invalidate() {
    return DetailActions.invalidate(AREA);
}

export function setPrilohaState(id, idTypPriloha, priloha) {
    return (dispatch, getState) => {
        const {app: {currentZadost}} = getState();
        if (currentZadost.data.id !== id) {
            return;
        }
        const index = indexById(currentZadost.data.prilohaList, idTypPriloha, 'idTypPriloha');
        let data;
        if (index === null) {
            data = {
                ...currentZadost.data,
                prilohaList: [
                    ...currentZadost.data.prilohaList,
                    priloha,
                ],
            };
        } else {
            data = {
                ...currentZadost.data,
                prilohaList: [
                    ...currentZadost.data.prilohaList.slice(0, index),
                    priloha,
                    ...currentZadost.data.prilohaList.slice(index + 1),
                ],
            };
        }
        dispatch(DetailActions.updateValue(AREA, data));
    };
}

export function setSubjekt(id, idRoleSubjekt, subjekt) {
    return (dispatch, getState) => {
        const {app: {currentZadost}} = getState();
        if (currentZadost.data.id !== id) {
            console.warn('ID ve store a ID v akci nejsou stejné!');
            return;
        }
        const index = indexById(currentZadost.data.subjektList, idRoleSubjekt, 'idRoleSubjekt');
        let data;
        if (index === null) {
            data = {
                ...currentZadost.data,
                subjektList: [
                    ...currentZadost.data.subjektList,
                    {
                        idRoleSubjekt,
                        subjekt,
                    },
                ],
            };
        } else {
            data = {
                ...currentZadost.data,
                subjektList: [
                    ...currentZadost.data.subjektList.slice(0, index),
                    {
                        ...currentZadost.data.subjektList[index],
                        idRoleSubjekt,
                        subjekt,
                    },
                    ...currentZadost.data.subjektList.slice(index + 1),
                ],
            };
        }
        dispatch(DetailActions.updateValue(AREA, data));
    };
}

export function deleteSubjekt(idZadost, idRoleSubjekt) {
    return (dispatch, getState) => {
        const {app: {currentZadost}} = getState();
        if (currentZadost.data.id !== idZadost) {
            console.warn('ID ve store a ID v akci nejsou stejné!');
            return;
        }
        const index = indexById(currentZadost.data.subjektList, idRoleSubjekt, 'idRoleSubjekt');
        let data;
        if (index !== null) {
            data = {
                ...currentZadost.data,
                subjektList: [
                    ...currentZadost.data.subjektList.slice(0, index),
                    ...currentZadost.data.subjektList.slice(index + 1),
                ],
            };
            dispatch(DetailActions.updateValue(AREA, data));
        }
    };
}

export function setZadatel(id, subjekt) {
    return (dispatch, getState) => {
        const {app: {currentZadost}} = getState();
        if (currentZadost.data.id !== id) {
            console.warn('ID ve store a ID v akci nejsou stejné!');
            return;
        }
        let data = {
            ...currentZadost.data,
            zadatel: {
                ...subjekt,
            },
        };
        dispatch(DetailActions.updateValue(AREA, data));
    };
}

export function deleteZadatel(idZadost) {
    return (dispatch, getState) => {
        const {app: {currentZadost}} = getState();
        if (currentZadost.data.id !== idZadost) {
            console.warn('ID ve store a ID v akci nejsou stejné!');
            return;
        }
        let data = {
            ...currentZadost.data,
            zadatel: null,
        };
        dispatch(DetailActions.updateValue(AREA, data));
    };
}


export function setLokalita(idZadost, lokalita) {
    return (dispatch, getState) => {
        const {app: {currentZadost}} = getState();
        if (currentZadost.data.id !== idZadost) {
            console.warn('ID ve store a ID v akci nejsou stejné!');
            return;
        }
        const index = indexById(currentZadost.data.lokalitaList, lokalita.id);
        let data;
        if (index === null) {
            data = {
                ...currentZadost.data,
                lokalitaList: [
                    ...currentZadost.data.lokalitaList,
                    lokalita,
                ],
            };
        } else {
            data = {
                ...currentZadost.data,
                lokalitaList: [
                    ...currentZadost.data.lokalitaList.slice(0, index),
                    {
                        ...currentZadost.data.lokalitaList[index],
                        ...lokalita,
                    },
                    ...currentZadost.data.lokalitaList.slice(index + 1),
                ],
            };
        }
        dispatch(DetailActions.updateValue(AREA, data));
    };
}

export function deleteLokalita(idZadost, idLokalita) {
    return (dispatch, getState) => {
        const {app: {currentZadost}} = getState();
        if (currentZadost.data.id !== idZadost) {
            console.warn('ID ve store a ID v akci nejsou stejné!');
            return;
        }
        const index = indexById(currentZadost.data.lokalitaList, idLokalita);
        let data;
        if (index !== null) {
            data = {
                ...currentZadost.data,
                lokalitaList: [
                    ...currentZadost.data.lokalitaList.slice(0, index),
                    ...currentZadost.data.lokalitaList.slice(index + 1),
                ],
            };
            dispatch(DetailActions.updateValue(AREA, data));
        }
    };
}
